module.exports = __webpack_public_path__ + "img/banner4.00651214.jpg";